export default __webpack_public_path__ + "static/FilsonSoftBook-a3fec83dace4bbab8f56d1204e6d6bef.ttf";